import React, { useState } from 'react';
import { Alert, Button, SvgIcArrowDown } from "@gofynd/nitrozen-react";
import "./style/linkedAccountDesc.css";
import learningsObj from "../assets/learning_links.json";
import { OpenInNew } from "@mui/icons-material";

const LinkedAccountDesc = (props) => {
  const { account } = props;
  const [showAllLearningLinks, setShowAllLearningLinks] = useState(false);
  const consoleDomain =
    process.env['REACT_APP_NEXT_PUBLIC_CONSOLE_DOMAIN'] ?? 'https://console.visenze.com';
  const accountHomePageUrl = `${consoleDomain}/en/${account.account_id}/home`;

  const isProcessingComplete = (typeof account.state !== "undefined") && (account.state === 3 || account.state === 4);
  const isProcessingSuccessful = (typeof account.state !== "undefined") && (account.state === 3);
  
  const goToConsole = (solution) => {
    if (isProcessingSuccessful) {
      const accountSolutionPageUrl = `${consoleDomain}/en/${account.account_id}/${solution}/app`;
      window.open(accountSolutionPageUrl, '_blank');
    } else {
      window.open(accountHomePageUrl, '_blank');
    }
  };

  function goToViewMore() {
    window.open('https://ref-docs.visenze.com/docs/how-discovery-suite-works', '_blank');
  }

  function goToLearningLink(url) {
    window.open(url, '_blank');
  }

  return (
    <div className="linked-account-container">
      <div className="solutions-container">
        <div className="title">Solutions</div>
        <div className="processing-banner-container" hidden={isProcessingComplete}>
          <Alert fullWidth={false}>
            We are collecting and processing your data. Please wait for it to be finished. An email will be sent once completed.
          </Alert>
        </div>
        <div className="solutions">
          <div className="solution-container">
            <img src="/recommendations.png" alt="recommendationsLogo" style={{ width: '24px', height: '24px' }}/>
            <div className="solution-title">Smart<br />Recommendation</div>
            <div className="solution-explanation">
              Make recommendations based on what your shoppers are seeing. Immediately increase cross-sell and up-sell opportunities for increased revenue impact with visual AI-powered Smart Recommendations.
            </div>
            <div className="console-link">
              <Button
                className="console-link-button"
                href=""
                onClick={() => goToConsole("recommendations")}
                disabled={!isProcessingComplete}
                rounded={false}
                size="small"
              >
                Go to Visenze DiscoverySuite
              </Button>
            </div>
          </div>
          <div className="solution-container">
            <img src="/search.png" alt="searchLogo" style={{ width: '24px', height: '24px' }}/>
            <div className="solution-title">Smart<br />Search</div>
            <div className="solution-explanation">
              Let your shoppers find what they want faster using a photo, saved image or screenshot. Smart Search enables visual search to complement your existing text-based search, so high-intent customers can discover, shop and convert instantly.
            </div>
            <div className="console-link">
              <Button
                className="console-link-button"
                href=""
                onClick={() => goToConsole("search")}
                disabled={!isProcessingComplete}
                rounded={false}
                size="small"
              >
                Go to Visenze DiscoverySuite
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="learning-links">
        <div className="learning-links-title">Learning Links</div>
        <hr />
        {(showAllLearningLinks ? learningsObj : learningsObj.slice(0, 3)).map((learningObj) => {
          return (
            <>
              <div className="learning-link" onClick={() => goToLearningLink(learningObj.link)}>
                <img src={learningObj.thumbnail_url} alt={learningObj.alt} style={{ width: '48px', height: '48px' }}/>
                <div className="learning-text">
                  {learningObj.title}
                </div>
              </div>
              <hr />
            </>
          );
        })}
        {!showAllLearningLinks ? (
          <div className="expand" onClick={() => setShowAllLearningLinks(true)}>
            Expand
            <SvgIcArrowDown
              className="arrow-next"
            />
          </div>
        ) : (
          <div className="view-more" onClick={() => goToViewMore()}>
            View more
            <OpenInNew />
          </div>
        )}
      </div>
    </div>
  )
}

export default LinkedAccountDesc;